<div class="card mt-12 w-full bg-white outline">
  <div class="card-body">
    <div class="card-title text-2xl">
      <h1>
        {{ "authentication.forgot-password.forgot-password" | translate }}
      </h1>
    </div>
    <form [formGroup]="form" (submit)="submit()">
      <fieldset>
        <legend>
          {{
            "authentication.forgot-password.forgot-password-hint" | translate
          }}
        </legend>
        <input
          type="email"
          required
          class="input"
          placeholder="{{ 'authentication.forgot-password.email' | translate }}"
          [formControl]="email"
        />

        @if (
          email.dirty && (email.hasError("required") || email.hasError("email"))
        ) {
          <p class="text-error">
            {{ "authentication.forgot-password.required" | translate }}
          </p>
        }
      </fieldset>

      <br />
      <button
        type="submit"
        [disabled]="form.invalid || isResetting()"
        class="btn btn-primary"
      >
        {{ "authentication.forgot-password.reset-password" | translate }}
      </button>
    </form>
  </div>
</div>
